module.exports = __webpack_public_path__ + "img/0.2da676bb.webp";